import baseObjJson from '../json/base.json';


export const baseObj = (set) => {
    return {
        baseObj: baseObjJson,
        setBaseObj: (next) => {
            set((state) => ({
                baseObj: { ...state.baseObj, ...next },
            }));
        },
    };
};
